import instance from "@/api/resetAxios";
import vm from "@/main";
import VueCookies from "vue-cookies";
let baseUrl = "https://schoolapi.eiceducation.com.cn/api";
let mockUrl = "https://kp-ipracticeapi.eiceducation.com.cn/api";
export const setEncryption = async info => {
  let res = await instance.get(
    `${baseUrl}/Encryption?content=${JSON.stringify(info)}`
  );
  if (res.data.code != 200) {
    vm.$message.error(res.data.msg);
  }
  return res;
};

export const addUserTask = async data => {
  let token = VueCookies.get("token");
  if (token) {
   let res =  await instance.post(`${baseUrl}/AdaptiveTest`, data, {
      headers: {
        token
      }
    });
    if (res.data.code != 200) {
      vm.$message.error(res.data.msg);
    }
  return res;
  } else {
    vm.$message.error("请登录后重试");
  }
};
export const setMockEncryption = async info => {
  let res = await instance.post(
    `${mockUrl}/other/encryption`,{ content: JSON.stringify(info) }
  );
  if (!res.data.succ) {
    vm.$message.error(res.data.message || res.data.msg);
  }
  return res;
};


// WEBPACK FOOTER //
// ./src/api/common.js